<template>
    <div>
        <b-spinner v-if="isLoading" type="grow" label="Loading..." class="loading" />
        <b-row v-else>
            <b-modal id="modal-add-appointment" ok-only :ok-title="$t('site.save')" centered @ok="save" size="lg"
                :title="$t('quran_programs.add_appointment')">
                <b-row>
                    <b-col md="4">
                        <b-form-group>
                            <h5>{{ $t("quran_programs.quran_program_time") }}</h5>
                            <flat-pickr v-model="newData.date" class="form-control" :config="{ dateFormat: 'Y-m-d' }" />
                        </b-form-group>
                    </b-col>

                    <b-col lg="4">
                        <b-form-group>
                            <h5>{{ $t("quran_programs.start_at") }}</h5>
                            <b-form-timepicker v-model="newData.start" locale="ar-EG" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4">
                        <b-form-group>
                            <h5>{{ $t("quran_programs.end_at") }}</h5>
                            <b-form-timepicker v-model="newData.end" locale="ar-EG" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-modal>
            <b-table striped hover bordered :items="items" :fields="tableFields" class="mb-3">
                <template #cell(alward)="data">
                    <span :ref="'row-' + data.item.alward">{{ data.item.alward }}</span>
                </template>
                <template #cell(partNumber)="data">
                    <span>الجزء : {{ data.item.partNumber }}</span>
                </template>
                <template #cell(alhizb)="data">
                    <b-badge variant="success" class="badge-glow">
                        الحزب : {{ data.item.alhizb }}
                    </b-badge>
                </template>
                <template #cell(quarter)="data">
                    <b-badge variant="info" class="badge-glow">
                        الربع : {{ data.item.quarter }}
                    </b-badge>
                </template>
                <template #cell(teacher)="data">
                    <b-badge variant="light-primary"
                        v-if="data.item.data && data.item.data.teachers && data.item.data.teachers.length > 0">
                        {{ data.item.data.teachers[0].full_name }}
                    </b-badge>
                </template>
                <template #cell(date)="data">

                    <b-badge variant="light-primary">
                        <small v-if="data.item.data && data.item.data.online_session">
                            <b-badge variant="light-primary">
                                {{ data.item.data.online_session.start_in }}
                            </b-badge>
                        </small>
                    </b-badge>
                </template>
                <template #cell(pass)="data">
                    <b-row v-if="data.item.data && data.item.data.online_session">
                        <b-col lg="12" class="text-center">
                            <b-card-text class="mb-0"> الاجتياز بنجاح </b-card-text>
                            <b-form-checkbox value="1" v-model="data.item.data.complete" class="custom-control-success"
                                name="check-button" switch :disabled="$role == 'student' || data.item.data.complete == 1
                                    " @change="complete(data.item.data)">
                                <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                </span>
                                <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                </span>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </template>

                <template #cell(actions)="data">
                    <!-- <b-button v-if="checkComplete(data.item) && (!data.item.item || !data.item.item.online_session)"
                        v-b-modal.modal-add-appointment @click="setSelectItem(data.item)" size="sm" variant="info">
                        تحديد الموعد
                    </b-button> -->
                    <b-button size="sm" variant="info" v-if="$role != 'student' && checkAllowedSelectTime(data.item)"
                        v-b-modal.modal-add-appointment @click="setSelectItem(data.item)">
                        تحديد الموعد

                    </b-button>
                    <b-button v-if="data.item.data && data.item.data.online_session" size="sm" variant="primary"
                        @click="openLive(data.item.data)">
                        دخول الجلسة
                    </b-button>
                    <b-button v-if="data.item.data && data.item.data.online_session" variant="primary" size="sm" class="mt-1" :to="{
                        name: 'OnlineDetails',
                        params: {
                            id: data.item.data.online_session.id,
                        },
                    }" block>
                        عرض الجلسات المسجلة
                    </b-button>
                </template>
            </b-table>
        </b-row>

    </div>

</template>

<script>
import controller from "@/Controllers/QuranScheduleDateController";
import QuranPrograms from "@/Controllers/QuranProgramsController";
import flatPickr from "vue-flatpickr-component";
import OnlineSessionController from "@/Controllers/OnlineSessionController";

const ctr = new controller();
let quranProgramCtr = new QuranPrograms();

export default {

    async created() {
        //get quranProgram data to get saveType , period started with
        let quranProgram = await quranProgramCtr.Show(this.$route.params.id);
        //calculate how many wards should exists from saveType and period
        let numberOfWards = 0;
        let saveType = quranProgram.SaveType;
        let period = quranProgram.period;
        //store to be able to use in getLastWard independently
        this.saveType = saveType;
        this.period = period;
        //testers
        // let saveType = 'desc';
        // let period = 5;
        if (saveType == 'desc') {
            numberOfWards = period * 8;
        } else {
            numberOfWards = (30 - period + 1) * 8
        }

        //setup items
        // partNumber == period
        for (let i = 1; i < numberOfWards + 1; i++) { //+1 since i = 1
            let partNumber = saveType == 'asc' ? period + Math.floor((i - 1) / 8) : period - Math.floor((i - 1) / 8);

            // Calculate the quarter (1-4)
            let quarter = ((i - 1) % 4) + 1;

            // Calculate the hizb (1 or 2)
            let alhizb = Math.ceil((i % 8) / 4);
            if (alhizb === 0) alhizb = 2; // Handle the case when i % 8 is 0

            this.items.push({
                alward: (partNumber - 1) * 8 + (quarter + (alhizb - 1) * 4),
                partNumber: partNumber,
                alhizb: alhizb,
                quarter: quarter
            });
        }

        //hydrate items with data
        await this.hydrateItems();

        // scroll to corresponding cell
        if (this.lastWardCompleted) {
            setTimeout(() => {
                let rowRef = this.$refs["row-" + this.lastWardCompleted];
                if (rowRef) {
                    let element = Array.isArray(rowRef) ? rowRef[0] : rowRef;
                    element?.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 500)


        }

        this.isLoading = false;
    },
    components: {
        flatPickr,
    },
    data() {
        return {
            sideImg: require("@/assets/images/pages/buldozer.png"),
            numberOfWards: 240,
            items: [],
            isLoading: true,
            lastWardCompleted: null,
            saveType: null,
            period: null,
            newData: {},
            tableFields: [
                { key: "alward", label: "الوِرْد" },
                { key: "partNumber", label: "الجزء" },
                { key: "alhizb", label: "الحزب" },
                { key: "quarter", label: "الربع" },
                { key: "teacher", label: "أعضاء هيئة التدريس" },
                { key: "date", label: "موعد المقرأة" },

                { key: "pass", label: "الأجتياز بنجاح" },
                { key: "actions", label: "الإجراءات" },
            ],
        }
    },
    methods: {
        apiParamsConverter() {
            const apiParams = { per_page: 240 };
            apiParams.with = ["teachers", "onlineSession", "students"];
            apiParams.filter = "quran_program_id|" + this.$route.params.id;
            apiParams.sort = "created_at|asc";
            return apiParams;
        },
        checkAllowedSelectTime(item) {
            //Completed
            if (item.data && item.data.complete == 1) return false;
            //If not completed get the order of current
            //If saveType == asc , so the order should be on the next ward not completed
            //If no data mean no assigned time
            //If online_class_id != 0 means that already assigned time
            if (this.saveType == 'asc') {
                if (item.alward === this.lastWardCompleted + 1) {
                    return !item.data || item.data.onlline_class_id === 0;
                }
            } else {
                //if last ward finished is last ward of current period means we need to shift backward
                //for example alward 16 (last of period 2), next one will be 1 (last of period 1)
                //else the next should have the order to assign normally
                if (this.lastWardCompleted % 8 == 0) {
                    if (this.lastWardCompleted - 15 == item.alward) {
                        return !item.data || item.data.onlline_class_id === 0;
                    }
                } else {
                    if (item.alward == this.lastWardCompleted + 1) {
                        return !item.data || item.data.onlline_class_id === 0;
                    }
                }
            }

            return false;
        },
        setSelectItem(item) {
            this.newDate = {};
            this.selectItem = item;
        },
        async hydrateItems() {
            const response = await ctr.GetAll(this.apiParamsConverter());
            const data = response.data;
            this.items.forEach(item => {
                const matchingItem = data.find(dataItem => dataItem.alward === item.alward);
                item.data = matchingItem ?? null;
            });

            //get last ward completed
            this.lastWardCompleted = this.getLastWardCompleted(this.items);
            if (!this.lastWardCompleted) { //just started no previous completted
                //make the last ward = the first ward should be taken - 1 in asc
                if (this.saveType == 'asc') {
                    this.lastWardCompleted = (this.period * 8) - 7 - 1
                } else {
                    this.lastWardCompleted = (this.period * 8) + 8
                }
            }

        },
        getLastWardCompleted(items) {
            if (!items || items.length === 0) return null;
            const completedItems = items.filter(item => item.data && item.data.complete === 1);

            if (completedItems.length === 0) return null;
            if (this.saveType === 'asc') {
                return completedItems.reduce((max, item) => item.alward > max.alward ? item : max).alward;
            } else {
                return completedItems.reduce((min, item) => item.alward < min.alward ? item : min).alward;
            }
        },
        async complete(item) {
            this.isLoading = true;
            await ctr.Updata(item);
            await this.hydrateItems();
            this.isLoading = false;
        },
        async save() {
            this.isLoading = true;
            if (this.selectItem.data) {
                this.newData.id = this.selectItem.data.id;
                this.newData.onlline_class_id = this.selectItem.data.onlline_class_id;
            }
            this.newData.alward = this.selectItem.alward;

            this.newData.quran_program_id = this.$route.params.id;

            this.newData.title =
                "- الجزء" +
                this.selectItem.partNumber +
                " - الحزب - " +
                this.selectItem.alhizb +
                "- الربع - " +
                this.selectItem.quarter;

            this.newData.systemic = 1;
            await ctr.From(this.newData, "FormData");

            await this.hydrateItems();
            this.isLoading = false
        },
        openLive(data) {
            new OnlineSessionController().joinLecture(data.online_session.id);
        },
    }

}


</script>